import React, { useState, useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import { grey } from '@mui/material/colors';
import { useNavigate } from 'react-router-dom';
import { useTheme } from "@mui/material/styles";
import { AuthContext } from '../../context/AuthContext';
import { useContext } from 'react';
import useApiManager from '../../utils/Api/apiManager';
import { ReactComponent as Logo } from '../../assets/logo-white.svg';
import EditUserProfile from '../Users/EditUserProfile';
import SearchIcon from '@mui/icons-material/Search';
import Search from '../Search/Search';


const drawerWidth = 240;

function ResponsiveAppBar() {
  const [pages, setPages] = useState(['Home', 'Leads', 'Contacts', 'Accounts', 'Campaigns', 'Deals', 'Tasks', 'Proposals']);
  //const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];
  const settings = ['Profile', 'Logout'];
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const navigate = useNavigate();
  const theme = useTheme();
  const { get } = useApiManager();
  const { logout, authToken, userInfo, setUserInfo } = useContext(AuthContext);
  const [editProfileDialog, setEditProfileDialog] = useState(false);
  const [searchDialog, setSearchDialog] = useState(false);

  useEffect(() => {
    const fetchUserRole = async () => {
      if (!authToken || userInfo) return; // Avoid fetching if already loaded

      try {
        const response = await get('/me'); // Fetch user info
        setUserInfo(response); // Update context with user info
        //const roles = response.roles;

      } catch (error) {
        console.error('Error fetching user role:', error);
      }
    };
    fetchUserRole();
    // Update pages based on roles
    setPages(prevPages => {
      let newPages = [...prevPages];

      // If user has only IdUser role, show only Proposals
      if (userInfo?.roles?.includes('IdUser') && userInfo?.roles?.length === 1) {
        return ['Proposals'];
      }

      // If user has IdUser role, add Proposals to pages
      if (userInfo?.roles?.includes('IdUser') && !newPages.includes('Proposals')) {
        newPages.push('Proposals');
      }

      if (userInfo?.roles?.includes('Admin') && !newPages.includes('Admin')) {
        newPages.push('Admin');
      }

      if ((userInfo?.roles?.includes('Admin') || userInfo?.roles?.includes('Manager')) && !newPages.includes('Reports')) {
        newPages.push('Reports');
      }

      if ((userInfo?.roles?.includes('Admin') || userInfo?.roles?.includes('Manager')) && !newPages.includes('Analytics')) {
        newPages.push('Analytics');
      }

      return newPages;
    });
  }, [authToken, userInfo, setUserInfo]);


  // when changing profile picture, to get the changes
  const fetchUserInfo = async () => {
    try {
      const response = await get('/me'); // Fetch user info
      setUserInfo(response); // Update context with user info
      //const roles = response.roles;

    } catch (error) {
      console.error('Error fetching user role:', error);
    }
  };

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = (page) => {
    setAnchorElNav(null);
    navigate(`/${page.toLowerCase()}`);
  };

  const handleCloseUserMenu = (setting) => {
    setAnchorElUser(null);
    if (setting == "Logout") {
      logout();
    }
    if (setting == "Profile") {
      setEditProfileDialog(true);
    }
  };

  return (
    <>
      <AppBar position="static" sx={{ backgroundColor: grey[900], zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Container maxWidth="false" sx={{ ml: 0 }}>
          <Toolbar disableGutters>
            {/* <Typography
            variant="h6"
            noWrap
            component="a"
            href=""
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            iLead
          </Typography> */}
            <Logo style={{ height: '17px', width: 'auto', marginRight: 15 }} />

            <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                open={Boolean(anchorElNav)}
                onClose={() => setAnchorElNav(null)}
                sx={{
                  display: { xs: 'block', md: 'none' },
                }}
              >
                {pages.map((page) => (
                  <MenuItem key={page} onClick={() => handleCloseNavMenu(page)}>
                    <Typography textAlign="center">{page}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>



            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
              {pages.map((page) => (
                <Button
                  key={page}
                  component="a"
                  href={`/${page.toLowerCase()}`}
                  rel="noopener noreferrer"
                  sx={{ my: 2, color: 'white', display: 'block' }}
                >
                  {page}
                </Button>
              ))}
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 0 }}>
              <IconButton sx={{ mr: 2 }} onClick={() => setSearchDialog(true)}>
                {userInfo?.roles?.includes('IdUser') ? null : (
                  <SearchIcon sx={{ color: 'white' }} />
                )}
              </IconButton>
              <Tooltip title="Edit Profile">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar src={`${userInfo?.profilePictureUrl}?${new Date().getTime()}`} />
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {settings.map((setting) => (
                  <MenuItem key={setting} onClick={() => handleCloseUserMenu(setting)}>
                    <Typography textAlign="center">{setting}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>

          </Toolbar>
        </Container>
      </AppBar>
      <EditUserProfile user={userInfo} open={editProfileDialog} onClose={() => {
        setEditProfileDialog(false);
        fetchUserInfo();
      }} />
      <Search open={searchDialog} onClose={() => setSearchDialog(false)} />
    </>
  );
}

export default ResponsiveAppBar;
